import { RestoreIcon } from '@repo/icons';
import { Dispatch } from 'redux';
import { restoreArchivedContactBatch } from '@repo/redux/actions/archive';
import { ArchiveViewState } from '@repo/utils/types';

export const RESTORE_HOTKEY = 'r';
// export const REMOVE_HOTKEY = '#';

// export const confirmToDelete = (
//   { contactBatch, contact }: { contactBatch?: Set<ID>; contact?: Contact },
//   dispatch: Dispatch,
// ) => {
//   let title = `Permanently remove ${contactBatch?.size} people`;
//   let ids = contactBatch;
//   let targetCopy = 'these people';

//   if (contactBatch.size < 2 && contact) {
//     title = `Permanently remove ${contact.displayName}`;
//     ids = Set([contact.id]);
//     targetCopy = 'this person';
//   }

//   window.app.confirm(
//     {
//       title,
//       message: `Are you sure you want to remove ${targetCopy} from Clay?`,
//       action: 'Remove',
//       variant: 'danger',
//     },
//     (confirmed) => {
//       if (confirmed) {
//         dispatch(deleteArchivedContactBatch(ids));
//       }
//     },
//   );
// };

export const buildArchiveActions = (archiveView: ArchiveViewState | null, dispatch: Dispatch) => {
  if (!archiveView || !archiveView.selectedContactBatch) {
    return [];
  }

  const { selectedContactBatch } = archiveView;
  // const contact = selectedContactBatch.size == 1 && selectedContact;

  return [
    {
      title: 'Restore to Clay',
      type: 'action',
      action: () => dispatch(restoreArchivedContactBatch(selectedContactBatch)),
      icon: RestoreIcon,
      keyboard: RESTORE_HOTKEY,
    },
    // {
    //   title: 'Remove Permanently',
    //   type: 'action',
    //   action: () => confirmToDelete({ contact, contactBatch: selectedContactBatch }, dispatch),
    //   icon: (props) => <XIcon {...props} style={{ height: 12, transform: 'none' }} />,
    //   keyboard: REMOVE_HOTKEY,
    //   synonyms: ['delete'],
    //   disabled,
    //   className: styles.deleteOption,
    // },
  ];
};
